module.exports = __webpack_public_path__ + "img/Slide2.82ac3775.png";